import React from 'react'
import {Link} from 'react-router-dom'
import he from 'he'

const ComedyContentPageCard = ({item,index}) => {


  const isTelugu = (text) => /[\u0C00-\u0C7F]/.test(text);
       
  return (
    <div className='comedy-contentpage-card'>
          <div className='text-center'>
             <Link to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/content')) : ''}
             className={`comedy-contentpage-card-title ${isTelugu(item.title) && item.title ? "comedy-contentpage-card-title-tl" : 'comedy-contentpage-card-title-en'}`}>{item.title ? item.title : "No Title"}</Link>
          </div>
            <Link to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/content')) : ''} >
            <img loading={'lazy'} fetchpriority="low" src={item.stimg ? item.stimg : '/comedy/assets/images/error_img.webp'} alt="card-img" className='comedy-contentpage-card-img' />
             </Link>
           <div className='text-center'>
            <p className="description" dangerouslySetInnerHTML={{ __html: (item.description ?  he.decode(item.description) : '')}}></p>
         </div>
        <div className="ms-auto"><button type="button"> <Link to={item.url_link ? item.url_link.substring(item.url_link.indexOf('/content')) : ''} className='w-100'>Continue..</Link></button></div>
    </div>
  )
}

export default ComedyContentPageCard;
